// Format the time as 12:30 31.07.2025
export const formatTime = (timeString: string) => {
    const date = new Date(timeString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${hours}:${minutes}`;
  };

// Format the timestamp for display
export const formatTimestamp = (timestamp: string | null) => {
    if (!timestamp) return 'never';
    const date = new Date(timestamp);
    return `${date.toLocaleTimeString()}`;
  };

// Calculate duration between start and end times
export const getDuration = (start: string, end: string) => {
  if (!start || !end) return '';
  
  // Check if we're dealing with time strings in format "HH:MM"
  if (start.match(/^\d{1,2}:\d{2}$/) && end.match(/^\d{1,2}:\d{2}$/)) {
    const [startHours, startMinutes] = start.split(':').map(Number);
    const [endHours, endMinutes] = end.split(':').map(Number);
    
    // Calculate total minutes
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    
    // Calculate duration in minutes
    let durationMins = endTotalMinutes - startTotalMinutes;
    
    // Handle case where end time is on the next day
    if (durationMins < 0) {
      durationMins += 24 * 60; // Add a full day of minutes
    }
    
    return durationMins === 1 ? '1 min' : `${durationMins} mins`;
  }
  
  // Handle full date strings
  try {
    const startDate = new Date(start);
    const endDate = new Date(end);
    
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error('Invalid date format:', { start, end });
      return '';
    }
    
    const durationMs = endDate.getTime() - startDate.getTime();
    const durationMins = Math.floor(durationMs / 60000);
    
    return durationMins === 1 ? '1 min' : `${durationMins} mins`;
  } catch (error) {
    console.error('Error calculating duration:', error);
    return '';
  }
};